import React from 'react'
import { Card, CardBody, Heading, Text } from '@eggplant-finance/eggplant-uikit-theme'
import BigNumber from 'bignumber.js/bignumber'
import styled from 'styled-components'
import { getBalanceNumber } from 'utils/formatBalance'
import { useTotalSupply, useBurnedBalance } from 'hooks/useTokenBalance'
import useI18n from 'hooks/useI18n'
import { getCakeAddress } from 'utils/addressHelpers'
import CardValue from './CardValue'
import { useFarms, usePriceCakeBusd } from '../../../state/hooks'

const StyledCakeStats = styled(Card)`
  margin-left: auto;
  margin-right: auto;
`

const Row = styled.div`
  align-items: center;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  margin-bottom: 8px;
`

const ModiCard = styled(Card)`
  align-self: baseline;
  background: ${({theme}) => theme.isDark ? 'rgba(0, 0, 0, 0.3)' : '#FFF'};
  border-radius: 32px;
  box-shadow: ${({theme})=> theme.isDark ? '0px 0px 5px 5px rgba(232, 226, 251, 0.2)' : '0px 0px 5px 5px rgba(107, 10, 128, 0.2)' };
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 24px;
  position: relative;
  text-align: center;
`

const ModiHeader = styled(Heading)`
  color: ${({theme})=> theme.isDark ? '#e8e2fb' : '#460a80'}
`

const ModiText = styled(Text)`
  color: ${({theme})=> theme.isDark ? '#e8e2fb' : '#000'}; 
`

const CakeStats = () => {
  const TranslateString = useI18n()
  const totalSupply = useTotalSupply()
  const burnedBalance = useBurnedBalance(getCakeAddress())
  const farms = useFarms()
  const eggPrice = usePriceCakeBusd()
  const circSupply = totalSupply ? totalSupply.minus(burnedBalance) : new BigNumber(0)
  const cakeSupply = getBalanceNumber(circSupply)
  const marketCap = eggPrice.times(circSupply)

  let eggpPerBlock = 0
  if (farms && farms[0] && farms[0].eggpPerBlock) {
    eggpPerBlock = new BigNumber(farms[0].eggpPerBlock).div(new BigNumber(10).pow(18)).toNumber()
  }

  return (
      <ModiCard>
      <CardBody>
        <ModiHeader size="xl" mb="24px">
          {TranslateString(534, 'EGGP Stats')}
        </ModiHeader>
        <Row>
          <ModiText fontSize="14px" bold>{TranslateString(536, 'Total Minted')}</ModiText>
          {cakeSupply && <CardValue fontSize="14px" value={cakeSupply} decimals={0} />}
        </Row>
        <Row>
          <ModiText fontSize="13px" bold>{TranslateString(1005, 'Market Cap')}</ModiText>
          <CardValue fontSize="14px" value={getBalanceNumber(marketCap)} decimals={0} prefix="$" />
        </Row>
        <Row>
          <ModiText fontSize="14px" bold>{TranslateString(538, 'Total Burned')}</ModiText>
          <CardValue fontSize="14px" value={getBalanceNumber(burnedBalance)} decimals={0} />
        </Row>
        <Row>
          <ModiText fontSize="14px" bold>{TranslateString(540, 'New EGGP/Block')}</ModiText>
          <ModiText bold fontSize="14px">
            {eggpPerBlock}
          </ModiText>
        </Row>
      </CardBody>
      </ModiCard>
  )
}

export default CakeStats
